import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/home/truck.jpg'
import _imports_1 from '@/assets/home/cylinders.jpg'
import _imports_2 from '@/assets/home/indura.png'
import _imports_3 from '@/assets/home/cryogas.png'


const _hoisted_1 = { style: {"display":"inline-flex","align-items":"center"} }
const _hoisted_2 = { style: {"flex":"0 1 auto"} }
const _hoisted_3 = {
  key: 0,
  src: _imports_0
}
const _hoisted_4 = {
  key: 1,
  width: "174",
  src: _imports_1
}
const _hoisted_5 = {
  key: 2,
  src: _imports_2
}
const _hoisted_6 = {
  key: 3,
  src: _imports_3
}
const _hoisted_7 = {
  key: 4,
  src: _imports_1
}
const _hoisted_8 = { style: {"flex":"1 1 auto","padding-left":"50px"} }
const _hoisted_9 = { class: "ap-green mb-0" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_card = _resolveComponent("b-card")

  return (_openBlock(), _createBlock(_component_b_card, { "no-body": "" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (['US', 'CA'].includes($props.countryCode))
            ? (_openBlock(), _createElementBlock("img", _hoisted_3))
            : (['AR', 'CL', 'CO', 'EC'].includes($props.countryCode))
              ? (_openBlock(), _createElementBlock("img", _hoisted_4))
              : ($props.company === 'Indura')
                ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                : ($props.company === 'Cryogas')
                  ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                  : (_openBlock(), _createElementBlock("img", _hoisted_7))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, [
            (['US', 'CA'].includes($props.countryCode))
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  innerHTML: _ctx.$t('ml_107025', { company: $props.company }, 'x-Save time online... with your account management system.')
                }, null, 8, _hoisted_10))
              : (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  innerHTML: _ctx.$t('ml_107026', { company: $props.company }, 'x-Everything you need to manage your Industrial Gases online')
                }, null, 8, _hoisted_11))
          ])
        ])
      ])
    ]),
    _: 1
  }))
}